appSocial.service('SocialTypes', function () {
    /**
     * @enum {string}
     */
    const ApiRequestAction = {
        Login: 'trader/login',
        GetPortfolio: 'trader/portfolio',
        GetFeed: 'trader/feed',
        GetLeaders: 'trader/leaders',
        FollowByLeader: 'trader/follow',
        UpdateFollowState: 'trader/follow',
        UpdateFollowDeposit: 'trader/follow/deposit',
        UnfollowLeader: 'trader/follow',
        GetFavorites: 'trader/favorites',
        AddFavorite: 'trader/favorites',
        DeleteFavorite: 'trader/favorites',
        GetTrades: 'trader/trades',
        GetAggregatedTrades: 'trader/trades/aggregated',
        GetTradesByMarkets: 'trader/trades/markets',
        GetGainHistory: 'trader/history/gain',
        GetRiskHistory: 'trader/history/risk',
        GetDailyData: 'trader/history/daily',
        UpdateVisitCounter: 'trader/visit',
        GetConversionRates: 'trader/configuration/rates',
        GetMarkets: 'trader/configuration/markets',
        GetExposure: 'trader/trades/exposure',

        //WS
        WsLogin: 'post.login',
    }

    /**
     * @enum {string}
     */
    const ApiMethod = {
        Post: 'POST',
        Get: 'GET',
        Put: 'PUT',
        Delete: 'DELETE',
        WS: 'ws'
    }

    /**
     * @enum {string}
     */
    const HistoryGranularity = {
        Daily: 'day',
        Monthly: 'month',
    }

    /**
     * @enum {string}
     */
    const FieldOperation = {
        Match: 'match',
        NotMatch: 'notmatch',
        Contain: 'contain',
        NotContain: 'notcontain',
        GreaterThan: 'gt',
        GreaterEqual: 'ge',
        LessThan: 'lt',
        LessEqual: 'le'
    }

    /**
     * @enum {string}
     */
    const Op = {
        And: 'and',
        Or: 'or'
    }

    /**
     * @enum {string}
     */
    const Dir = {
        Desc: 'desc',
        Asc: 'asc'
    }

    /**
     * @enum {string}
     */
    const FilterTag = {
        All: 'all',
        MostCopied: 'most-copied',
        EditorsChoice: 'editors-choice',
        Profitable: 'profitable',
        Trending: 'trending',
        Top: 'top',
        Similar: 'similar'
    }

    /**
     * @enum {string}
     */
    const FeedView = {
        Grid: 'grid',
        List: 'list'
    }

    /**
     * @enum {string}
     */
    const DateRange = {
        CurrentMonth: 'currentMonth',
        LastMonth: 'lastMonth',
        LastTwoMonths: 'lastTwoMonth',
        LastThreeMonths: 'lastThreeMonth',
        LastSixMonths: 'lastSixMonth',
        ThisYear: 'thisYear',
        TheseTwoYears: 'thisTwoYears',
        All: 'all'
    }

    /**
     * @enum {string}
     */
    const CopyAction = {
        StartCopy: 'startCopy',
        StopCopy: 'stopCopy',
        AddFunds: 'addFunds',
        RemoveFunds: 'removeFunds',
        Pause: 'pauseCopy',
        Resume: 'resumeCopy',
        SetStopLoss: 'setStopLoss',
        SetReachedStopLoss: 'setReachedStopLoss'
    }

    /**
     * @enum {string}
     */
    const AccountType = {
        NotAllowed: 'notAllowed',
        Allowed: 'Allowed',
        Limited: 'Limited'
    }

    /**
     * @enum {string}
     */
    const ChartType = {
        InvestedCapital: 'investedCapital',
        Copiers: 'copiers',
        Views: 'views'
    }

    /**
     * @enum {string}
     */
    const WidgetMode = {
        Open: 'open',
        Closed: 'closed'
    }

    /**
     * @enum {string}
     */
    const WidgetView = {
        Grid: 'grid',
        Chart: 'chart'
    }

    /**
     * @enum {string}
     */
    const WidgetStatus = {
        Success: 'success',
        Fail: 'fail',
        Empty: 'empty',
        Unknown: 'unknown',
        Loading: 'loading',
    }

    /**
     * @enum {string}
     */
    const CardMode = {
        Compare: 'compare'
    }

    /**
     * @enum {string}
     */
    const ValidationTypes = {
        MinAmount: 'minAmount',
        MaxAmount: 'maxAmount',
        Balance: 'balance'
    }

    /**
     * @name SocialTypes
     * @class
     */
    return {
        ApiRequestAction,
        ApiMethod,
        HistoryGranularity,
        FieldOperation,
        Op,
        Dir,
        FilterTag,
        FeedView,
        DateRange,
        CopyAction,
        AccountType,
        ChartType,
        WidgetMode,
        WidgetView,
        WidgetStatus,
        CardMode,
        ValidationTypes
    }
})
